import { useEffect, useMemo, useState, VFC } from 'react';

import ReactSelect from 'dashboard/components/ReactSelect';
import ParamLabel from 'dashboard/components/WorkflowControlPanel/ParamLabel';
import useWorkflowError from 'dashboard/components/WorkflowControlPanel/useWorkflowError';
import { filterUsableObjects, UsableObjectConfig } from 'dashboard/lib/workflows';
import { WorkflowError, WorkflowFieldObjectKey } from 'dashboard/models/workflow';
import { WorkflowActionTrustDeviceFromInquiryV1 } from 'dashboard/models/workflow-version';
import Spacer from 'design-system/components/Spacer';

interface ParamsTrustDeviceFromInquiryV1Props {
  editable: boolean;
  errors: WorkflowError[];
  params: WorkflowActionTrustDeviceFromInquiryV1['params'];
  usableObjects: UsableObjectConfig[];
  updateActionParams: (newParams: WorkflowActionTrustDeviceFromInquiryV1['params']) => void;
}

const ParamsTrustDeviceFromInquiryV1: VFC<ParamsTrustDeviceFromInquiryV1Props> = ({
  editable,
  errors,
  params,
  usableObjects,
  updateActionParams,
}) => {
  const possibleObjects = useMemo(() => {
    return filterUsableObjects({
      usableObjects,
      options: {
        permittedObjects: [WorkflowFieldObjectKey.Inquiry],
        excludeNonPersonaObjects: true,
      },
    });
  }, [usableObjects]);

  const selectInquiry = (value: string) => {
    updateActionParams({
      ...params,
      inquiry: value,
    });
  };
  const [singleOption, setSingleOption] = useState(false);
  useEffect(() => {
    if (possibleObjects.length === 1) {
      selectInquiry(possibleObjects[0].value);
      setSingleOption(true);
    }
  }, []);

  const { hasErrorFor, renderErrorMessageFor } =
    useWorkflowError<keyof WorkflowActionTrustDeviceFromInquiryV1['params']>(errors);

  return (
    <>
      <Spacer height={2} />
      <ParamLabel labelText='Inquiry' htmlFor='params-trust-device-from-inquiry__inquiry-input' />
      <ReactSelect
        value={params['inquiry']}
        options={possibleObjects}
        onChange={selectInquiry}
        disabled={!editable || singleOption}
        hasError={hasErrorFor('inquiry')}
        id='params-trust-device-from-inquiry__inquiry'
      />
      {renderErrorMessageFor('inquiry')}
    </>
  );
};

export default ParamsTrustDeviceFromInquiryV1;
